import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import "../styles/tables.css";
import { useAuth } from "../context/AuthContext";

function ManageCategories() {
  const { token } = useAuth();
  const navigate = useNavigate();

  const [categories, setCategories] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [search, setSearch] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const categoriesPerPage = 10;

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {

    try {

      const response =
        await api.get("/categories");

      setCategories(
        response.data
      );

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);

    }

  };

  const handleDelete = async (id) => {

    const result =
      await Swal.fire({
        title: "Delete Category?",
        text:
          "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#021658",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel"
      });

    if (!result.isConfirmed) {
      return;
    }

    try {

      await api.delete(
        `/categories/${id}`,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      setCategories(
        categories.filter(
          (category) =>
            category.id !== id
        )
      );

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text:
          "Category deleted successfully.",
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text:
          error.response?.data
            ?.message ||
          "Unable to delete category."
      });

    }

  };

  const filteredCategories =
    categories.filter(
      (category) =>
        category.name
          .toLowerCase()
          .includes(
            search.toLowerCase()
          )
    );

  const indexOfLastCategory =
    currentPage *
    categoriesPerPage;

  const indexOfFirstCategory =
    indexOfLastCategory -
    categoriesPerPage;

  const currentCategories =
    filteredCategories.slice(
      indexOfFirstCategory,
      indexOfLastCategory
    );

  const totalPages =
    Math.ceil(
      filteredCategories.length /
      categoriesPerPage
    );

  if (loading) {
    return (
      <div>
        <Navbar />
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className="container">

        <h1>
          Manage Categories
        </h1>

        <input
          type="text"
          placeholder="Search categories..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
          className="search-input"
        />

        <div className="table-wrapper">

          <table className="custom-table">

            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Slug</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>

              {currentCategories.map(
                (category) => (
                  <tr
                    key={category.id}
                  >
                    <td>
                      {category.id}
                    </td>

                    <td>
                      {category.name}
                    </td>

                    <td>
                      {category.slug}
                    </td>

                    <td>
                      {
                        category.description
                      }
                    </td>

                    <td>

                      <button
                        title="Edit Category"
                        className="icon-btn edit-btn"
                        onClick={() =>
                          navigate(
                            `/categories/edit/${category.id}`
                          )
                        }
                      >
                        <FaEdit />
                      </button>

                      <button
                        title="Delete Category"
                        className="icon-btn delete-btn"
                        onClick={() =>
                          handleDelete(
                            category.id
                          )
                        }
                      >
                        <FaTrash />
                      </button>

                    </td>
                  </tr>
                )
              )}

            </tbody>

          </table>

        </div>

        <div className="pagination">

          <button
            disabled={
              currentPage === 1
            }
            onClick={() =>
              setCurrentPage(
                currentPage - 1
              )
            }
          >
            Previous
          </button>

          <span>
            Page {currentPage} of{" "}
            {totalPages || 1}
          </span>

          <button
            disabled={
              currentPage ===
                totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setCurrentPage(
                currentPage + 1
              )
            }
          >
            Next
          </button>

        </div>

      </div>
    </div>
  );
}

export default ManageCategories;